import { Injectable } from '@angular/core';
import { CustomProduct } from '@product/const';
import { Converter, ConverterService, Occ, PRODUCT_NORMALIZER, ProductReference } from '@spartacus/core';

@Injectable({ providedIn: 'root' })
export class ProductReferencesListNormalizer implements Converter<Occ.ProductReferenceList, ProductReference[]> {
  constructor(private converter: ConverterService) {}

  convert(source: Occ.ProductReferenceList, target?: ProductReference[]): ProductReference[] {
    if (!target) {
      return target.filter((reference: ProductReference) => reference.target.stock.stockLevel);
    }

    if (source && source.references) {
      target = source.references
        .filter((reference: Occ.ProductReference) => reference.target.stock.stockLevel)
        .map((reference: Occ.ProductReference) => ({
          ...reference,
          target: this.converter.convert<any, CustomProduct>(reference.target, PRODUCT_NORMALIZER),
        }));

      return target;
    }

    return target;
  }
}
